// @flow
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as sessionActionCreators from "../../action-creators/session-actions";
import * as modalActionCreators from "../../action-creators/modal-actions";
import "./styles.css";
import Layout from "../../components/layout";
import TrashMap from "../../components/trash-map";
import { Card } from "../../components/card";
import LeaderBoard from "../../components/leader-board";
import type TrashDrop from "../../models/trash-drop";
import type User from "../../models/user";
import type Team from "../../models/team";


type PropsType = {
    pickupLocations: any[],
    dropOffLocations: any[],
    user: User,
    teams: Team[],
    trashDrops: ?TrashDrop,
    teamMembers: ?TeamMember
};


const MyScreen = ({
    pickupLocations,
    dropOffLocations,
    user,
    teams,
    trashDrops,
    teamMembers
}: PropsType) => (
    
     
    <div className={ "dashboard" }>
        <Card className={ "dashboard--trash-map" }>
            <TrashMap
                dropOffLocations={ dropOffLocations }
                pickupLocations={ pickupLocations }
                teams={ teams }
                trashDrops={ trashDrops }/>
        </Card>
        <Card className={ "dashboard--leader-board" }>
            <LeaderBoard teams={ teams } trashDrops={ trashDrops } teamMembers={ teamMembers }/>
        </Card>
    </div>

);


const mapStateToProps = (state: Object): Object => {
    const user = state.session.user || {};
    const teams = (state.teams || {}).data || {};
    const trashDrops = (state.trashDrops || {}).data || {};
    const teamMembers = (state.teamMembers || {}).data || {};
    const error = (state.trashDrops || {}).error;
    const pickupLocations = Object.values(state.supplyDistributionSites.data).filter(site => (site.coordinates || {}).latitude && (site.coordinates || {}).longitude);
    const dropOffLocations = Object.values(state.trashCollectionSites.data).filter(site => (site.coordinates || {}).latitude && (site.coordinates || {}).longitude);
    return { user, trashDrops, error, pickupLocations, dropOffLocations, teams, teamMembers };
};

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators({ ...sessionActionCreators, modalActionCreators }, dispatch)
});

export const DashboardScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);


